module.exports = __webpack_public_path__ + "img/descarga-icon.f01664e5.png";